"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ensureDirExists = exports.ensureFileExists = exports.populateVariableFromPath = exports.readStringFromPath = exports.readObjectFromPath = exports.outputToPath = exports.createDir = exports.dirExist = exports.hasFile = void 0;
const tslib_1 = require("tslib");
const fs_1 = tslib_1.__importDefault(require("fs"));
const promises_1 = require("fs/promises");
const path_1 = tslib_1.__importDefault(require("path"));
const debugOverride = process.env.DEBUG_OVERRIDE === 'true';
const debug = (!process.env.AWS_SESSION_TOKEN && false) || debugOverride;
const hasFile = (pathIn, fileName) => new Promise((resolve, reject) => {
    let res = { err: null, data: null };
    fs_1.default.stat(path_1.default.join(pathIn, fileName), (err, stats) => {
        if (err) {
            res.err = new Error(err.message);
        }
        else if (stats.isFile()) {
            res.data = true;
        }
        resolve(res);
    });
});
exports.hasFile = hasFile;
const dirExist = (path) => new Promise((resolve, reject) => {
    let res = { err: null, data: null };
    fs_1.default.stat(path, (err, stats) => {
        if (err) {
            res.err = new Error(err.message);
        }
        else if (stats.isDirectory()) {
            res.data = true;
        }
        resolve(res);
    });
});
exports.dirExist = dirExist;
const createDir = (path) => new Promise((resolve, reject) => {
    let res = { err: null, data: null };
    fs_1.default.mkdir(path, { recursive: true }, (err) => {
        if (err) {
            res.err = new Error(err.message);
        }
        else {
            res.data = true;
        }
        resolve(res);
    });
});
exports.createDir = createDir;
const outputToPath = async (dirPath, fileName, output) => {
    let res = { err: null, data: null };
    const isDir = await (0, exports.dirExist)(dirPath);
    let exists = false;
    if (!isDir.data) {
        const createRes = await (0, exports.createDir)(dirPath);
        if (createRes.data) {
            exists = true;
            console.log(`Created directory: ${dirPath}`);
        }
        else {
            res = createRes;
        }
    }
    else {
        exists = true;
    }
    if (exists) {
        const filePath = path_1.default.join(dirPath, fileName);
        const fileExists = await (0, exports.hasFile)(dirPath, fileName);
        if (fileExists.data) {
            debug && console.log(`overwriting ${filePath}`);
        }
        else {
            debug && console.log('Err in outputToPath', fileExists);
        }
        let outputStr = undefined;
        try {
            outputStr = JSON.stringify(output, null, 1);
        }
        catch (e) {
            res.err = new Error(`Stringify threw error,: ${e.message}`);
        }
        if (typeof outputStr === 'string') {
            res = await new Promise((resolve, reject) => fs_1.default.writeFile(filePath, outputStr, { encoding: 'utf-8' }, (err) => resolve({ err, data: !err ? true : null })));
        }
    }
    return res;
};
exports.outputToPath = outputToPath;
// reads a file into an object, the
const readObjectFromPath = async (dirPath, fileName) => {
    let res = { err: null, data: null };
    const existsRes = await (0, exports.hasFile)(dirPath, fileName);
    if (existsRes.data === true) {
        const obStrRes = await new Promise((resolve, reject) => fs_1.default.readFile(path_1.default.join(dirPath, fileName), { encoding: 'utf-8' }, (err, data) => resolve({ err, data })));
        try {
            if (obStrRes.data) {
                res.data = JSON.parse(obStrRes.data);
            }
        }
        catch (e) {
            if (e instanceof Error) {
                res.err = e;
            }
        }
    }
    else {
        res.err = new Error(`readObjectFromPath: ${existsRes.err}`);
    }
    return res;
};
exports.readObjectFromPath = readObjectFromPath;
const readStringFromPath = async (dirPath, fileName) => {
    let res = { err: null, data: null };
    const existsRes = await (0, exports.hasFile)(dirPath, fileName);
    debug && console.log(`${dirPath}.${fileName} exists ${existsRes.data} `);
    if (existsRes.data === true) {
        res = await new Promise((resolve, reject) => fs_1.default.readFile(path_1.default.join(dirPath, fileName), { encoding: 'utf-8' }, (err, data) => resolve({ err, data })));
    }
    else {
        res.err = existsRes.err;
    }
    return res;
};
exports.readStringFromPath = readStringFromPath;
const populateVariableFromPath = async ({ variable, dirPath, fileName }) => {
    const readRes = await (0, exports.readObjectFromPath)(dirPath, fileName);
    if (readRes.data) {
        if (typeof readRes.data === 'object' && !(readRes.data instanceof Array)) {
            for (let [k, v] of Object.entries(readRes.data)) {
                variable[k] = v;
            }
        }
    }
    else {
        console.log(`Swallowing Err ${readRes.err?.message}`);
    }
};
exports.populateVariableFromPath = populateVariableFromPath;
const ensureFileExists = async (filePath) => {
    const handle = await (0, promises_1.open)(filePath, 'a');
    await handle.close();
};
exports.ensureFileExists = ensureFileExists;
const ensureDirExists = async (dirPath) => {
    const { err, data } = await (0, exports.dirExist)(dirPath);
    if (!data) {
        await (0, exports.createDir)(dirPath);
    }
};
exports.ensureDirExists = ensureDirExists;
